export default [
  {
    path: "/index.html",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/Principal.vue"),
    alias: "/",
    meta: {
      requiresAuth: true,
    },
  },
];
